import React from "react";
import usePreferredLanguageToggle from "../hooks/usePreferredLanguageToggle";

export default function PreferredLanguageToggle({ profile }) {
  const {
    currentPreferredLanguage,
    handleLanguageToggle,
    isPending,
  } = usePreferredLanguageToggle(profile);
  const targetLanguage = currentPreferredLanguage === "HI" ? "English" : "Hindi";

  return (
    <button
      type="button"
      className={`start-quiz-shell__icon start-quiz-shell__icon--language${currentPreferredLanguage === "HI" ? " is-hi" : ""}${isPending ? " is-loading" : ""}`}
      aria-label={`Switch language to ${targetLanguage}`}
      title={`Current language: ${currentPreferredLanguage}. Click to switch to ${targetLanguage}`}
      onClick={handleLanguageToggle}
      disabled={isPending}
    >
      <i className="bi bi-translate" aria-hidden="true" />
      <span className="start-quiz-shell__language-badge">{currentPreferredLanguage}</span>
    </button>
  );
}